var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import * as RenderMethods from "./RenderMethods";
var AggregateCard = /** @class */ (function (_super) {
    __extends(AggregateCard, _super);
    function AggregateCard(props) {
        var _this = _super.call(this, props) || this;
        _this.renderEventsCount = RenderMethods.renderEventsCount;
        _this.renderCardDetails = RenderMethods.renderCardDetails;
        _this.renderArrow = RenderMethods.renderArrow;
        _this.componentPrefix = "aggregate-card";
        return _this;
    }
    AggregateCard.prototype.render = function () {
        return (React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix, "data-uat": "div-ev-list-" + this.componentPrefix },
            React.createElement("a", { className: "rj-ev-list__" + this.componentPrefix + "__link", href: this.props.event.linkUrl, onClick: this.props.handler, key: this.componentPrefix + "__link__" + this.props.event.id, "data-uat": "a-ev-list-" + this.componentPrefix + "-link" },
                this.renderEventsCount(this.props.event.aggregatedEventsCount, this.componentPrefix),
                this.renderCardDetails(this.props, this.componentPrefix),
                this.renderArrow(this.componentPrefix))));
    };
    AggregateCard = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], AggregateCard);
    return AggregateCard;
}(React.Component));
export { AggregateCard };
//# sourceMappingURL=AggregateCard.js.map